import React from 'react';
import { DropdownButton } from 'react-bootstrap';
import DownloadReportIcon from '../../icons/DownloadReportIcon.jsx';
import './ChangeImpactActionDropdown.module.css';
import CustomMenuItem from '../../CustomMenuItem.jsx';

const ChangeImpactActionDropdown = ({
  viewType,
  isReportLoading,
  onDownloadReport,
}) => {
  return (
    <div className="actions">
      <DropdownButton
        noCaret
        title=""
        id="id"
        className="btn-more btn btn-default"
      >
        {viewType === 'pie' ? (
          <span>
            <CustomMenuItem>
              <button
                className="flex flex-align-center w-100 h-100 p-0 btn-clear bg-transparent"
                disabled={isReportLoading}
                onClick={onDownloadReport}
              >
                <DownloadReportIcon />
                &nbsp;
                <span className="m-l-8">
                  {isReportLoading ? 'Loading...' : 'Download Report'}
                </span>
              </button>
            </CustomMenuItem>
          </span>
        ) : null}
      </DropdownButton>
    </div>
  );
};

export default ChangeImpactActionDropdown;
